import { Expose, Type } from "class-transformer";
import { PdfAcroFormFieldTypeEnum } from "@/core/features/employee-onboarding/pdf-acro-form-field-type.enum";

export class PdfAcroFormWidgetDto {
  @Expose()
  name: string;

  @Expose()
  type: PdfAcroFormFieldTypeEnum;

  @Expose()
  @Type(() => Number)
  pageNumber: number;

  @Expose()
  @Type(() => Number)
  xRatio: number;

  @Expose()
  @Type(() => Number)
  yRatio: number;

  @Expose()
  @Type(() => Number)
  widthRatio: number;

  @Expose()
  @Type(() => Number)
  heightRatio: number;

  @Expose()
  options: string[];

  @Expose()
  exportValue: string | null;

  @Expose()
  isReadOnly: boolean;

  @Expose()
  isRequired: boolean;

  @Expose()
  isMultiline: boolean;

  @Expose()
  maxLength: number | null;

  @Expose()
  currentValue: string;
}
